import type { MapRef } from "react-map-gl/maplibre";

// Replaces the `mapRefSignal` preact signal.
//
// It is written in exactly one place (the <Map> ref callback). It was read in exactly one
// place (the zustand actions in state/map.slice.ts), never during a render, and that is
// why this is a plain module holder rather than a store: a signal whose value no component
// reads in render never fires a subscription, and keeping a live MapLibre instance out of
// any state container is worth it.
//
// One read now happens during a render — `ActiveLegPill` projects the leg's endpoints to
// turn its arrow toward the next stop. That is still not a subscription, and does not need
// to be: the pill's parent re-renders it on every map `move` event to keep the viewport
// state in sync, which is exactly the set of changes that can move those pixels. It reads
// numbers off the map rather than holding on to it, which is the part that must not change.
let mapRef: MapRef | null = null;

export const getMapRef = () => mapRef;

export const setMapRef = (ref: MapRef | null) => {
  mapRef = ref;
};
